<template>
  <div class="fi-plan-board" :class="{ 'fi-plan-board--horizon': horizonNavActive, 'fi-plan-board--midnight': midnightActive }" style="margin:20px">

    <FiPageRail title="Planned - Vehicle Utilization Daily" />

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 20px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
    </div>

    <div v-if="!loading" style="margin: 20px;">
      <div class="row" style="margin: 10px; font-weight: bold; font-size: 24px;">
        <div style="padding:8px;" class="col d-flex align-items-center justify-content-center">{{items.length}} of {{summary.total_cnt}}</div>
        <div style="padding:8px;" class="col d-flex align-items-center justify-content-center">
          <b-form-select v-model="vehicle_mode" :options="vehicle_mode_options" style="font-size: 18px; font-weight: bold; width:120px"/>
        </div>
        <div style="padding:8px;" class="col d-flex align-items-center justify-content-center">
          Filter Results:&nbsp;<b-form-input style="width: 250px" v-model="search_filter" placeholder=""/>
        </div>
      </div>
      <div class="row" style="margin: 10px; font-weight: bold; font-size: 20px; flex-wrap: nowrap; overflow-x: auto;">
        <template v-for="type_stat in summary.vehicle_type_stats">
          <div v-if="selected_types.indexOf(type_stat.type) > -1" @click="filter_by_type(type_stat.type)" class="col" :style="typeChipStyle(type_stat.color, true)">{{type_stat.total_cnt}} - {{type_stat.type}} [{{vehicle_mode === 'booked' ? type_stat.count : vehicle_mode === 'available' ? type_stat.total_cnt - type_stat.count : type_stat.total_cnt}}]</div>
          <div v-else @click="filter_by_type(type_stat.type)" class="col" :style="typeChipStyle(type_stat.color)">{{type_stat.total_cnt}} - {{type_stat.type}} ({{vehicle_mode === 'booked' ? type_stat.count : vehicle_mode === 'available' ? type_stat.total_cnt - type_stat.count : type_stat.total_cnt}})</div>
        </template>
      </div>
    </div>

    <div v-if="!loading">
      <table width="100%" border='1' cellpadding='0' cellspacing="0">
        <thead>
        <tr>
          <th colspan="8">&nbsp;</th>
          <th v-if="vehicle_status_disabled" colspan="3">&nbsp;</th>
          <th style='background-color: #ddd;' colspan="24">{{this.details_fromDate}}</th>
        </tr>
        <tr>
          <th width="80px" @click="sort_strings('vehicle')">Vehicle &#8597;</th>
          <th width="90px" @click="sort_numbers('charterIDs')">BookingID &#8597;</th>
          <th width="80px" @click="sort_strings('vehicle_type')">Vehicle Type &#8597;</th>
          <th width="80px" @click="sort_strings('drivers')">Driver &#8597;</th>
          <th width="90px" v-if="!vehicle_status_disabled" @click="sort_strings('vehicle_status')">Status &#8597;</th>
          <th width="90px" v-if="!vehicle_status_disabled" @click="sort_strings('maintenance_status')">Maint &#8597;</th>
          <th width="100px" @click="sort_dates('start_datetime')">Start Time &#8597;</th>
          <th width="100px" @click="sort_dates('finish_datetime')">Finish Time &#8597;</th>
          <th width="15px" style="background-color: #ddd; font-size: 12px; font-weight: bold" v-for="hour in hours_display">{{hour}}</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(item, row_num) in items">
          <tr @click="toggle_div(item,'isMvmtsVisible')">
            <td>{{ item.vehicle | trim(12)}}</td>
            <td>
              <span v-if="item.charterIDs && item.charterIDs.includes(',')">+{{item.charterIDs.split(',')[0]}}</span>
              <span v-else>{{item.charterIDs}}</span>
            </td>
            <td>{{item.vehicle_type}}</td>
            <td>{{ item.drivers | trim(20)}}</td>
            <td v-if="!vehicle_status_disabled">{{item.vehicle_status}}</td>
            <td v-if="!vehicle_status_disabled">{{item.maintenance_status}}</td>
            <td>{{item.start_datetime | formatDateTimeSmall(item.timezone)}}</td>
            <td>{{item.finish_datetime | formatDateTimeSmall(item.timezone)}}</td>
            <td v-for="hour in hours">
              <table width="100%" border="0" cellpadding='0' cellspacing="0">
                <tr>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,15)'>&nbsp;</td>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,30)'>&nbsp;</td>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,45)'>&nbsp;</td>
                  <td :style='getStyleForVeh(details_fromDate,hour,item,60)'>&nbsp;</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr v-if="item.isMvmtsVisible" v-for="assignment in item.assignments">
            <td colspan="1" align="right" style="font-weight: bold">&nbsp;</td>
            <td>{{ assignment.charterID }}</td>
            <td>&nbsp;</td>
            <td>{{ assignment.driver }}</td>
            <td v-if="!vehicle_status_disabled">&nbsp;</td>
            <td v-if="!vehicle_status_disabled">&nbsp;</td>
            <td>{{assignment.start_datetime | formatDateTimeSmall(assignment.timezone)}}</td>
            <td>{{assignment.finish_datetime | formatDateTimeSmall(assignment.timezone)}}</td>
            <td v-for="hour in hours">
              <table width="100%" border="0" cellpadding='0' cellspacing="0">
                <tr>
                  <td :style="getStyleForMvmt(details_fromDate,hour,assignment,15,'lightgreen')">&nbsp;</td>
                  <td :style="getStyleForMvmt(details_fromDate,hour,assignment,30,'lightgreen')">&nbsp;</td>
                  <td :style="getStyleForMvmt(details_fromDate,hour,assignment,45,'lightgreen')">&nbsp;</td>
                  <td :style="getStyleForMvmt(details_fromDate,hour,assignment,60,'lightgreen')">&nbsp;</td>
                </tr>
              </table>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import {get_tbn_vehicle_utilization} from "../networking/tbn_apis";
import horizonNav from '@/nav/horizon_nav_mixin'
import typeChipColors from '@/helpers/type_chip_colors'

export default {
  name: 'utilization_tbn',

  mixins: [horizonNav, typeChipColors],

  components: {
  },

  data() {
    return {
      vehicle_status_disabled: false,
      items: [],
      items_full: [],
      reloading: false,
      reload_mode: 0,
      timer: null,
      search_filter: '',
      selected_vehicle_status: '',
      selected_maintenance_status: '',
      selected_types: [],
      vehicle_mode: 'all',
      vehicle_mode_options: [
        { text: 'All', value: 'all' },
        { text: 'Booked', value: 'booked' },
        { text: 'Available', value: 'available' },
      ],
      summary: [],
      hours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
      hours_display: ['12am','1am','2am','3am','4am','5am','6am','7am','8am','9am','10am','11am','12pm','1pm','2pm','3pm','4pm','5pm','6pm','7pm','8pm','9pm','10pm','11pm'],
      quarters: [0,15,30,45],
      loading: true,
      details_fromDate: justDate(moment()),
      details_toDate: justDate(moment().add(1, 'days')),
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    async check_features() {
      this.vehicle_status_disabled = !this.user.features[this.user.tenant].vehicle_status_management_enabled
      this.load_data()
    },
    async load_data() {
      this.loading = true
      try {
        this.selected_types = []
        this.sort_col = 'vehicle'

        const { value: { data = [] }} = await get_tbn_vehicle_utilization(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items_full = data.results
        this.items = data.results
        this.filter_items()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    getStyleForMvmt(fromDate,hour,mvmt,minutes,color) {
      let slice_found = false;
      let fromDateObj = moment(fromDate,'MM-DD-YYYY')

      let start_date = moment(mvmt.start_date,'MM-DD-YYYY')
      let finish_date = moment(mvmt.finish_date,'MM-DD-YYYY')

      let start_hour = parseInt(mvmt.start_hour)
      let start_min = parseInt(mvmt.start_min)
      let finish_hour = parseInt(mvmt.finish_hour)
      let finish_min = parseInt(mvmt.finish_min)

      //console.log("checking: " + fromDate + ":" + hour + ":" + minutes + " against " + mvmt.start_date + ":" + start_hour + ":" + start_min + " - " + mvmt.finish_date + ":" + finish_hour + ":" + finish_min);

      if (start_date < fromDateObj && fromDateObj < finish_date) {
        slice_found = true;
      }
      else if (start_date < fromDateObj && finish_date >= fromDateObj) {
        if (hour < finish_hour || (hour == finish_hour && finish_min >= minutes )) {
          slice_found = true;
        }
      }
      else if (finish_date > fromDateObj && start_date <= fromDateObj) {
        if (start_hour < hour || (hour == start_hour && start_min <= minutes )) {
          slice_found = true;
        }
      }
      else if (start_date <= fromDateObj && fromDateObj <= finish_date) {

        //console.log("partial day found: " + hour + "," + start_hour + ":" + finish_hour);

        if (start_hour == finish_hour && start_min == finish_min) {
          //console.log("start == finish");
        }
        else if (start_hour < hour && hour < finish_hour) {
          //console.log("complete hour found");
          slice_found = true;
        }
        else if (start_hour <= hour && hour <= finish_hour) {
          //console.log("partial hour found: " + hour);
          if (start_hour == hour && start_min <= minutes) {
            //console.log("start minute found");
            slice_found = true;
          }
          else if (finish_hour == hour && finish_min >= minutes) {
            //console.log("finish minute found");
            slice_found = true;
          }
        }
      }

      if (slice_found)
        return 'background-color:' + color
      else
        return ''
    },
    getStyleForVeh(fromDate,hour,item,minutes) {
      for (const mvmt of item.assignments) {
        let resp = this.getStyleForMvmt(fromDate, hour, mvmt, minutes,'green');
        if (resp != '')
          return resp;
      }
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_by_status(status) {
      if (status == null || this.selected_vehicle_status == status) {
        this.selected_vehicle_status = null
        this.items = this.items_full
      } else {
        this.selected_vehicle_status = status
        this.items = this.items_full.filter(item => item.vehicle_status == status.toUpperCase())
      }
    },
    filter_by_maint_status(status) {
      if (status == null || this.selected_maintenance_status == status) {
        this.selected_maintenance_status = null
        this.items = this.items_full
      } else {
        this.selected_maintenance_status = status
        this.items = this.items_full.filter(item => item.maintenance_status == status.toUpperCase())
      }
    },
    filter_by_type(type) {
      const idx = this.selected_types.indexOf(type)
      if (idx > -1) {
        this.selected_types.splice(idx, 1)
      } else {
        this.selected_types.push(type)
      }
      this.filter_items()
    },
    filter_items() {
      this.items = this.items_full
      if (this.vehicle_mode === 'booked')
        this.items = this.items.filter(item => item.assignments && item.assignments.length > 0)
      else if (this.vehicle_mode === 'available')
        this.items = this.items.filter(item => !item.assignments || item.assignments.length === 0)
      if (this.search_filter)
        this.items = this.items.filter(item => this.contains(item.vehicle, this.search_filter) || this.contains(item.charterIDs, this.search_filter) || this.contains(item.drivers, this.search_filter))
      if (this.selected_types.length > 0)
        this.items = this.items.filter(item => this.selected_types.indexOf(item.vehicle_type) > -1)
    },
    sort_dates(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {

            if (a[col] && a[col].includes(','))
              a[col] = a[col].split(',')[0]

            if (b[col] && b[col].includes(','))
              b[col] = b[col].split(',')[0]

            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    clean_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'CLEANED').length
    },
    dirty_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'DIRTY').length
    },
    out_cnt() {
      return this.items_full.filter(item => item.vehicle_status == 'OUT').length
    },
    ready_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'READY').length
    },
    pending_dvir_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'PENDING_DVIR').length
    },
    unsafe_dvir_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'UNSAFE_DVIR').length
    },
    oos_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'OOS').length
    },
    pm_cnt() {
      return this.items_full.filter(item => item.maintenance_status == 'PM').length
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    vehicle_mode() {
      this.selected_types = []
      this.filter_items()
    },
    search_filter(val) {
      this.filter_items()
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      this.details_toDate = justDate(moment(target_from_date,'MM-DD-YYYY').add(1, 'days'));
      this.load_data();
    },
  }
}
</script>
<style scoped>

.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
a {color: darkred}

/* ticket 1808: freeze the header block so the column labels (and the date
   banner above them) stay put while scrolling a long vehicle list. sticky on
   <thead> rather than on th: this header is two rows, and a blanket
   `th { top: 0 }` would pin both rows to the same offset and stack them on
   top of each other. */
thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

/* the stuck header needs a background of its own -- without one the data rows
   scroll through it. the explicit border keeps the header's grid lines matching
   the table's border="1" body cells, the same treatment the other planned and
   actuals boards give their sticky headers. */
thead th {
  background-color: #F9F8F8;
  border: 1px solid black;
}

/* the horizon/midnight shell's top bar is position: fixed, so a header stuck
   at top: 0 slides underneath it -- park it below the bar instead. the
   variable is published on <html> by fi_favorites_bar.vue and already accounts
   for the favorites row; classic has no fixed chrome, so it keeps top: 0. */
.fi-plan-board--horizon thead {
  top: var(--fi-hz-top-offset, 52px);
}

</style>


